import { TempValue } from "components/temp-value"
import { fetchData } from "utils/fetch-data"
import parseHtml from "utils/parse-html"

import { getCells } from "./freezing-graph/cells"
import { getPoints } from "./freezing-graph/polyline"

export const KEY_DAY = "days"
export const KEY_GRAPH = "freezing-graph"
export const KEY_SUMMARY = "summary"
export const KEY_TABS = "tabs"

function tableSections(table, keyFn) {
  const cells = []
  const tables = Array.isArray(table) ? table : [table]

  for (const t of tables) {
    for (let rowI = 0; rowI < t.rows.length; rowI++) {
      const row = t.rows[rowI]
      const key = keyFn ? keyFn(row, rowI) : row.dataset.row
      if (!key) continue

      let dayI = 0
      let cellI = 0

      Array.from(row.cells).forEach((cell) => {
        if (cell.tagName == "TH") return

        if (!cells[dayI]) cells[dayI] = {}
        if (!cells[dayI][key]) cells[dayI][key] = []
        cells[dayI][key].push(cell)

        cellI += cell.colSpan
        const { days } = cells[dayI]
        if (days && days.length && cellI >= days[0].colSpan) {
          cellI = 0
          dayI++
        }
      })
    }
  }

  return cells
}

export default class ForecastTableData {
  constructor(url, elevs, defaultElev, defaultModel) {
    this.url = url
    this.elevs = elevs
    this.defaultModel = defaultModel
    this.defaultElev = defaultElev
  }

  // eslint-disable-next-line class-methods-use-this
  parse(table, remove) {
    const cells = tableSections(table)
    if (!cells[0].time) return { cells: null }

    let graph = cells[0][KEY_GRAPH]

    for (let d = 0; d < cells.length; d++) {
      delete cells[d].full
      delete cells[d][KEY_GRAPH]

      if (remove) {
        Object.keys(cells[d]).forEach((key) => {
          cells[d][key].forEach((cell) => cell.remove())
        })
      }
    }

    if (graph && graph.length) {
      ;[graph] = graph
      TempValue.init(graph)
      const elevs = getCells(graph)
      const curveLines = [...graph.querySelectorAll(".curve-line")]
      const points = curveLines.map((l) => getPoints(l))

      let start = 0
      for (let i = 0; i < cells.length; i++) {
        const dayCells = cells[i]
        const size = dayCells.time.length
        const end = start + size
        dayCells[KEY_GRAPH] = [
          elevs.map((elevCells) => elevCells.slice(start, end)),
          points.map((linePoints) => linePoints.slice(start, end)),
        ]
        start += size
      }
    }

    return { cells, graph }
  }

  async fetch(model, elev, details) {
    const url = this.buildUrl(`model=${model}&elev=${elev}&detail=${details.join(",")}`)
    const data = await fetchData(url)
    if (!data) return null

    const doc = parseHtml(data.table)
    const tables = Array.from(doc.body.querySelectorAll("[data-content]"))
    const { cells } = this.parse(tables, true)

    return cells
  }

  async fetchPast(model, elev, date, complete) {
    let url = this.buildUrl(`model=${model}&elev=${elev}&past_date=${date}`)
    if (complete) url += "&complete=1"

    const data = await fetchData(url)
    if (!data.table) return data

    const doc = parseHtml(data.table)
    const [table] = doc.body.childNodes
    const { cells } = this.parse(table)
    delete data.table
    return { cells, ...data }
  }

  buildUrl(query) {
    const sep = this.url.indexOf("?") !== -1 ? "&" : "?"
    return `${this.url}${sep}${query}`
  }
}
